import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileImportError } from '../../../app/shared/types/data-import/file-import-error';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './data-import-error-dialog.html',
  styleUrls: ['./data-import-error-dialog.scss']
})
export class DataImportErrorDialog {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: FileImportError
  ) {}
}
